import React from 'react';
import { Legacy } from '../components/Legacy';
import { Award, Shield, Users, Target } from 'lucide-react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function LegacyPage() {
  return <PageWrapper data-id="element-603">
      <div className="bg-white" data-id="element-604">
        <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-605">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-606">
            <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-4" data-id="element-607">
              Our Legacy
            </h1>
            <p className="text-tech-slate max-w-2xl text-lg opacity-80" data-id="element-608">
              5 years of unwavering commitment to federal excellence and secure
              innovation.
            </p>
          </div>
        </div>
        <SectionWrapper data-id="element-609">
          <Legacy data-id="element-610" />
        </SectionWrapper>
        <section className="py-16 bg-white" data-id="element-611">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-612">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-613">
              {[{
              icon: Shield,
              title: 'Integrity',
              desc: 'Uncompromising adherence to NIST and HIPAA standards.'
            }, {
              icon: Target,
              title: 'Precision',
              desc: 'Mission-focused engineering with zero margin for error.'
            }, {
              icon: Users,
              title: 'Service',
              desc: 'Dedicated partnership with every agency we serve.'
            }, {
              icon: Award,
              title: 'Excellence',
              desc: 'A track record of on-time, on-budget delivery.'
            }].map((item, i) => <SectionWrapper key={item.title} delay={i * 0.08} data-id="element-614">
                  <div className="p-6 border border-slate-200 rounded-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 h-full" data-id="element-615">
                    <item.icon className="w-8 h-8 text-muted-gold mb-4" data-id="element-616" />
                    <h3 className="font-bold text-federal-blue mb-2" data-id="element-617">
                      {item.title}
                    </h3>
                    <p className="text-sm text-tech-slate opacity-80" data-id="element-618">
                      {item.desc}
                    </p>
                  </div>
                </SectionWrapper>)}
            </div>
          </div>
        </section>
      </div>
    </PageWrapper>;
}